import * as xml2js from 'xml2js'
import {ScheduleEvents} from "./ScheduleEvents";
import {PlayerBase} from '../../player/player.base';
import {ComponentClasses} from '../../player/component.classes';
import {EventParams} from '../EventParams/event.params';
import {IPlayerService} from '../../interfaces/IPlayerService';
import {ComponentFactoryResolver, Injector, NgZone, ViewContainerRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IPlayer} from '../../interfaces/IPlayer';
import {SceneComponent} from '../../components/scene/scene.component';
import {libVersion} from '../../libVersion';
import {Log, LogTag} from '../Log';
import {
  Subject,
  Observable,
  of,
  BehaviorSubject,
  switchMap,
  concatMap,
  forkJoin,
  shareReplay
} from 'rxjs';
import {delay, map, repeat} from 'rxjs/operators';
import {CachingService} from "../caching/caching.service";
import {Expiration} from "../../interfaces/Expiration";
import {YouTube} from "./YouTube";
import {ChromeExtension} from "../Watchdog/ChromeExtension";
import {Extension} from "../Watchdog/Extension";
import {AndroidExtension} from "../Watchdog/AndroidExtension";
import {ILogInfo} from "../../interfaces/ILogInfo";
import {Stats} from "./stats";


enum ResellerProgram { Free, Plus, Enterprise}


export class PlayerBaseService implements IPlayerService {
  ngZone: NgZone;
  resolver: ComponentFactoryResolver;

  static OS_WINDOWS = "Windows";
  static OS_LINUX = "Linux";
  static OS_ANDROID = "Android";
  static OS_UNKNOWN = "Unknown";

  protected _os: string;
  protected _appType: string
  private _fpsInterval = null;
  appVersion: string;
  libVersion = libVersion;

  isLocalHost = false;

  circularSceneId = -1;


  deviceAdmin;

  domain = null;
  private _businessId = -1;
  private _businessDomain: string = null;
  socketDomain = null;

  resellerId = 1;

  stationId = -1;
  stationToken = "";
  webToken = "";

  playing$;
  playerChannel$;
  studioChannel$;

  sceneId;

  httpClient; //???
  eventParams: EventParams;
  data = {};
  caching: CachingService;
  componentClasses: ComponentClasses;
  stats: Stats;

  initYoutube$;
  youtubeId = 0;

  extension: Extension;
  domains = {};
  ruleId = 0;

  schedules = {}

  startTime;


  resellerProgram: ResellerProgram = ResellerProgram.Free;





  freeComponents = {
    4102: true, // Playlist
    3345: true, // Rss
    3241: true, // Label
    3242: true, // LabelQueue
    3320: true, // Clock
    3100: true, // Video
    3130: true, // Image
    3140: true, // Svg
    6010: true, // Weather
    4210: true, // JsonItem
    4310: true, // JsonItem
  }


  plusComponents = {
    3346: true, // CustomRssPlayer
    3348: true, // CustomRssItem
    3335: true, // StockItem
    3338: true, // StockTicker
    3270: true, // CatalogItem
    3280: true, // CatalogPlayer
    4200: true, // XmlPlayer
    3322: true, // Countdown
    3430: true, // Qr
    3150: true, // ExtVideoComponent
    3160: true, // ExtImageComponent
    4104: true, // SchedulerComponent
  }


  constructor(protected  injector: Injector) {
    Log.init(this);
    const logInfo = Log.getLogInfo("PlayerBaseService", "constructor", []);

    this.ngZone = injector.get(NgZone);

    if (Log.config.enabled) {
      setInterval(() => {
        this.postLog();
      }, 60000)
    }

    Log.i(logInfo, LogTag.INIT, "signPlayerLib version = " + libVersion);

    this.resolver = injector.get(ComponentFactoryResolver);
    this.httpClient = injector.get(HttpClient);
    this.eventParams = injector.get("eventParams");
    this.caching = injector.get("cachingService");
    window['rxjs'] = { of: of, Observable: Observable, switchMap: switchMap, concatMap: concatMap, repeat: repeat, delay: delay, forkJoin: forkJoin }
    this.componentClasses = new ComponentClasses();

    this.isLocalHost = (document.location.host.indexOf('localhost') != -1);
    Log.d(logInfo, LogTag.PLAYER_SERVICE, 'isLocalHost: ' + this.isLocalHost);

    this.updateOS()



    const isAndroid = (window.navigator.userAgent.indexOf("Android") != -1);
    // const isAndroid = true;

    this.extension = isAndroid ? new AndroidExtension() : new ChromeExtension();

    this.playing$ = new BehaviorSubject('start');
    this.playerChannel$ = new Subject();
    this.studioChannel$ = new Subject();

    this.startTime = new Date().getTime();
  }


  updateOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("windows") != -1) {
      this._os = PlayerBaseService.OS_WINDOWS;
    } else if (userAgent.indexOf("android") != -1) {
      this._os = PlayerBaseService.OS_ANDROID;
    } else if (userAgent.indexOf("linux") != -1 || (userAgent.indexOf("mac") != -1)) {
      this._os = PlayerBaseService.OS_LINUX;
    } else {
      this._os = PlayerBaseService.OS_UNKNOWN;
    }
  }

  get os(): string {
    return this._os;
  }

  reload(): void {
    location.reload();
  }

  get showFps(): boolean {
    return this._fpsInterval != null;
  }

  set showFps(value:boolean) {
      console.error('show fps not supported')
  }


  get appType(): string {
    return this._appType;
  }

  set appType(value: string) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "set appType", []);
    Log.d(logInfo, LogTag.PLAYER_SERVICE, value);
    this._appType = value;
  }

  get extensionVersion(): string {
    return "";
  }

  get businessId(): number {
    return this._businessId;
  }

  set businessId(value: number) {
    this._businessId = value;
    this.caching.businessId = this._businessId;
  }

  get businessDomain(): string {
    return this._businessDomain;
  }

  set businessDomain(value: string) {
    this._businessDomain = value;
    this.caching.businessDomain = this._businessDomain;
  }


  clearSchedules() {
    for(let scheduleId in this.schedules) {
      const scheduleEvents: ScheduleEvents = this.schedules[scheduleId];
      scheduleEvents.destroy();
    }
    this.schedules = {};
  }

  clearCircular(): void {
    this.circularSceneId = -1;
  }

  setDevMode(mode: boolean) {
    const logInfo = Log.getLogInfo("PlayerBaseService", "setDevMode", []);
    Log.i(logInfo, LogTag.PLAYER_SERVICE, '');
    Log.devMode = mode;
  }


  getSceneId(): Observable<any> {
    return of(null);
  }

  createScene(entry: ViewContainerRef, parentPlayer: IPlayer, editMode: boolean): IPlayer {
    this.clearCircular();
    const factory = this.resolver.resolveComponentFactory(SceneComponent);
    const componentRef = entry.createComponent(factory);
    const player = <PlayerBase>componentRef.instance;
    player.init(parentPlayer, editMode, -1);
    player.component.nativeElement.className = "root-scene";
    return player;
  }

  removeScene(entry: ViewContainerRef, player: IPlayer): void {
    const logInfo = Log.getLogInfo("PlayerBaseService", "removeScene", [player]);
    (<PlayerBase>(player)).destroy();
    if (entry.length > 0) {
      entry.remove(0);
    }
  }


  init():Observable<any> {
    const logInfo = Log.getLogInfo("PlayerBaseService", "init-v2", []);
    return of ('init');
  }

  stationStats(): Observable<any>
  {
    return of(null);
  }


  allowDomain(url): Observable<any> {
    const logInfo = Log.getLogInfo("PlayerBaseService", "allowDomain", [url]);
    Log.d(logInfo, LogTag.PLAYER_SERVICE, this.os);
    if (this.os==PlayerBaseService.OS_ANDROID) {
      return of('ignore');
    }

    let domain;
    try {
      let urlObj = (new URL(url));
      domain = urlObj.hostname;
      if (domain == "") {
        return of(null);
      }
    } catch (e) {
      return of(null);
    }


    let domain$: Observable<any> = this.domains[domain];
    if (domain$==null) {
      this.ruleId++;
      this.domains[domain] = domain$ = this.extension.call('allowDomain', {ruleId: this.ruleId, domain: domain});
    }
    return domain$;
  }


  online(): Observable<any> {
    if (navigator.onLine) {
      return of('online');
    } else {
      return new Observable( sub => {
        let interval = setInterval( () => {
          if (navigator.onLine) {
            clearInterval(interval);
            sub.next('online');
            sub.complete();
          }
        }, 10000)
      })
    }
  }

  initYoutube(): Observable<any> {
    if (this.initYoutube$==null) {
      this.initYoutube$ = this.online().pipe(
        switchMap( a=> {
          return new Observable<string>( sub => {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window["onYouTubeIframeAPIReady"] = () => {
              sub.next('ready');
              sub.complete();
            }
          })
        }),
        delay(1000),
        shareReplay()
      )
    }
    return this.initYoutube$;
  }

  play() {
    this.playing$.next('start');
  }

  stop() {
    this.playing$.next('stop');
  }

  isPlaying(): boolean {
    return this.playing$.value == 'start';
  }

  updateCustomerInfo(): Observable<any> {
    const url: string = 'https://' + this.domain + '/Web/getCustomerInfo.ashx?businessId=' + this.businessId + "&ver=1.5";
    return this.caching.requestJson(url,'webservice', Expiration.Hour).pipe(
      map(data => {
        this.businessDomain = data.businessDomain;
        this.socketDomain = data.socketDomain;
        this.resellerId = data.resellerId;


        if (data.resellerPaying) {
          if (data.pricingMethod==1 || data.pricingMethod==3) {
            this.resellerProgram = ResellerProgram.Enterprise;
          } else if (data.pricingMethod==2) {
            this.resellerProgram = ResellerProgram.Plus;
          }
        }
        return true;
      })
    )
  }

  getComponentBlockingTime(playerId) {
    if (this.resellerProgram==ResellerProgram.Enterprise || this.freeComponents[playerId]) {
      return -1;
    }
    if (this.resellerProgram==ResellerProgram.Plus && this.plusComponents[playerId]) {
      return -1;
    }

    console.log("playerId="+playerId+ " will be blocked");

    const runningTime = (new Date().getTime()) - this.startTime;
    const leftTime = Math.max(10 * 60 * 1000 - runningTime, 5000);
    return leftTime;
  }

  getComponentClasses(playerId): PlayerBase {
    const logInfo = Log.getLogInfo("PlayerBaseService", "getComponentClasses", [playerId]);
    let myClass = this.componentClasses.releaseClasses[playerId];

    if (myClass==null) {
      Log.e(logInfo, LogTag.PLAYER_SERVICE, 'playerId not exist in componentClasses');
    }
    return myClass;
  }


  startServerSocket() {
  }

  saveStationInfo(): Observable<any> {
    return of(null);
  }

  parseString(xml: string, fnc: Function) {
    xml2js.parseString(xml, fnc);
  }

  getServiceUrl() {
    const url = 'https://' + this.businessDomain +
      '/Web/loadData.ashx?businessId=' + this.businessId +
      '&stationId=' + this.stationId;
    return url;
  }

  getProxyUrl() {
    const url = 'https://' + this.businessDomain + '/Web/getProxyRequest.ashx'
    return url;
  }


  getSceneList():Observable<any> {
    const url = 'https://' + this.businessDomain + '/Web/getSceneList.ashx?businessId=' + this.businessId;
    return this.caching.requestJson(url,'webservice', Expiration.Now);
  }

  loadDb(callback) {
    /*
    const url = this.getServiceUrl();
    Log.d('loadDb: ' + url);
    this.localStorageService.getData(url).then(
      (data) => {
        this.db = JSON.parse(data);
        this.db.scenes = {};
        Log.d("loadDb time: " + this.db.time);
        this.populateTransitionPools();
        this.populateScheduleEvents();
        Log.d('loadDb success');
        callback();
      });

     */
  }

/*
  populateTransitionPools() {
    this.transitionPools = {};
    for (let key in this.dbService.db.transitionPoolItems) {
      const item = this.dbService.db.transitionPoolItems[key];
      const poolId = item.transition_pool_id;
      let pool = this.transitionPools[poolId];
      if (pool==null) {
        pool = this.transitionPools[poolId] = [];
      }

      const xmlData = item.transition_item_data
      xml2js.parseString(xmlData, (err, result) => {
        const data = result.Transition.$;
        pool.push(data);
      });
    }
  }
*/


  createScheduleEvents(scheduleId): ScheduleEvents {
    let scheduleEvents: ScheduleEvents = this.schedules[scheduleId];
    if (scheduleEvents==null) {
      this.schedules[scheduleId] = scheduleEvents = new ScheduleEvents(this, scheduleId);
    }
    return scheduleEvents;
  }

  loadScript(scriptId):Observable<any> {
    return this.caching.getRecord("scripts", scriptId).pipe(
      switchMap(code => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.text = code.script_src;
        document.getElementsByTagName('head')[0].appendChild(script);
        //document.body.appendChild(script);
        return of("script");
      })
    )
  }


  createScriptClass(className, params) {
    const cls:any = window[className];
    const instabce = Object.create(cls.prototype);
    instabce.constructor.apply(instabce, [this, JSON.parse(params)]);
    return instabce;
  }

  captureScreen(fileName: string, scale: number) {
  }
/*
  startCapture(): Observable<any> {
    return new Observable<any>(sub => {
        const displayMediaOptions:DisplayMediaStreamConstraints = new class implements DisplayMediaStreamConstraints {
        audio: false;
        video: true;
        video: true;
      };
      navigator.mediaDevices.getDisplayMedia(displayMediaOptions).then(captureStream => {
        sub.next(true);
        sub.complete();
      }).catch((err) => {
        console.error(`Error:${err}`);
        return of(null);
      });
    })
  }
*/

  loadProviderData(eventName, source, url, folder): Observable<any> {
    const logInfo = Log.getLogInfo("PlayerBaseService", "loadProviderData", [eventName, url]);
    if (source=='cloud') {
      url = 'https://' + this.businessDomain +
        '/Web/eventParam.ashx?command=getEvent' +
        '&businessId=' + this.businessId +
        '&eventName=' + eventName;
      return this.caching.requestText(url, 'eventparams', Expiration.Now).pipe(
        map(res => {
          if (res==null || res=="") {
            Log.w(logInfo, LogTag.PLAYER, "loadProviderData() res is Empty");
            return null;
          }
          try {
            return JSON.parse(<string>res)
          } catch (e) {
            Log.w(logInfo, LogTag.PLAYER, 'JSON.parse() ' + res);
            return null;
          }
        })
        /*
        tap( res => {
          if (res!="") {
            const value = JSON.parse(res);
            this.eventParams.dispatch(eventName, value, true);
          }
        })

         */
      )
    } else if (source=='external') {
      if (url=="") {
        Log.w(logInfo, LogTag.PLAYER_SERVICE, "url is empty");
        return of(null);
      }
      return this.caching.requestText(url, folder, Expiration.Now).pipe(
        map(res => {
          if (res==null || res=="") {
            Log.w(logInfo, LogTag.PLAYER, "res is Empty");
            return null;
          }
          try {
            return JSON.parse(<string>res)
          } catch (e) {
            Log.w(logInfo, LogTag.PLAYER, 'JSON.parse() ' + res);
            return null;
          }

        })
        /*
        tap(res => {
          const value = JSON.parse(res);
          this.eventParams.dispatch(eventName, value, true);
        })

         */
      )
    } else {
      Log.e(logInfo, LogTag.PLAYER_SERVICE, source + ' not supported');
      return of(null);
    }
  }

  saveDataProvider(eventName, providerData, broadcast): Observable<any> {
    return new Observable<any>( sub => {
      const url = "https://" + this.businessDomain + "/Web/eventParam.ashx?command=setEvent&stationToken=" + this.stationToken + "&businessId=" + this.businessId + "&eventName=" + eventName + "&broadcast=" + broadcast + "&fromStationId=" + this.stationId;
      const data = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(providerData)
      }
      fetch(url, data).then(response => {
        response.text().then(txt => {
          sub.next('txt');
          sub.complete();
        })
      }).catch(error => {
        Log.debug();
        sub.error(error);
      })
    })
  }


  getSettingParam(paramKey): Observable<any> {
    return new Observable<any>( sub => {
      const url = "https://" + this.businessDomain + "/Web/globalSetting.ashx?command=getParam&businessId=" + this.businessId + "&paramKey=" + paramKey;
      const data = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
      fetch(url, data).then(response => {
        response.text().then(txt => {
          sub.next(txt);
          sub.complete();
        })
      }).catch(error => {
        Log.debug();
        sub.error(error);
      })
    })
  }

  getAyreshareToken(): Observable<any> {
    return this.getSettingParam('ayreshare_token').pipe(
      map( info => JSON.parse(info).refId),
      shareReplay()
    )
  }


  sendPttBlob(stations, emergency, data) {
  }

  setPtt(enabledPtt) {

  }

  createYouTube(nativeElement): YouTube {
    this.youtubeId++;
    return new YouTube(nativeElement, this.youtubeId);
  }

  getLogTags() {
    return Object.values(LogTag);
  }

  log(priority: number, sender: ILogInfo, tag: String, message: String) {
    let log = (localStorage["log"] != null) ? JSON.parse(localStorage["log"]) : new Array();
    const data = {
      time: new Date().getTime(),
      priority: priority,
      className: sender?.className,
      fncName: sender?.fncName,
      fncArgs: sender?.fncArgs,
      tag: tag,
      message: message,
    };
    log.push(data);
    localStorage["log"] = JSON.stringify(log);
  }

  postLog() {
    if (Log.config.enabled && localStorage["log"]!=null && localStorage["log"]!="" && localStorage["log"]!="[]") {
      const url = "https://"+this.businessDomain+"/Web/log.ashx?businessId=" + this.businessId + "&stationId=" + this.stationId + "&stationToken=" + this.stationToken + "&command=write";
      const data = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: localStorage["log"]
      }
      fetch(url, data).then(response => {
        response.text().then(txt => {
          localStorage["log"] = "[]";
        })

      }).catch(error => {
        // ignore send if no internet and try next time
      })
    }
  }

  dispose() {
    const logInfo = Log.getLogInfo("PlayerBaseService", "dispose", []);
    Log.d(logInfo, LogTag.DISPOSE, '');
  }
}
